import { LinkList } from '@ahc-digital/component-library';
import { GetLinkListModel } from './C08LinkList.service';
import { translationClasses } from '@/shared/TranslationClasses';
import { useCreateMarketingRenderingHame } from '@/shared/useCreateMarketingRenderingName';
import { checkDatasourceForRendering } from '@/shared/checkDatasourceForRendering';
import { C08LinkListProps } from './C08LinkList.types';

const Default = (props?: C08LinkListProps) => {
  const marketingRenderingName = useCreateMarketingRenderingHame(
    props?.rendering?.componentName as string
  );

  const model = GetLinkListModel(props);
  return (
    <LinkList
      className={translationClasses(props?.params)}
      id={props?.params?.AnchorLinkTargetName}
      data-component={marketingRenderingName}
      {...model}
    />
  );
};

export default checkDatasourceForRendering<C08LinkListProps>(Default);
